import { get, has, map, omit, forEach, pickBy } from "lodash";
import { formatPurse } from "@tvg/formatter/currency";
import { RaceProgram, RaceListItem } from "@tvg/ts-types/Race";

const createRaceDataForHeader = (
  race: RaceProgram,
  enableRaceChanges: boolean = false
): RaceListItem[] => {
  const keysRace = [
    "numWagerableRunners",
    "distance",
    "surface.shortName",
    "surface.defaultCondition",
    "raceClass.shortName",
    "type.shortName",
    "purse"
  ];

  const changesKeyMap: Record<string, string> = {
    distance: "distance",
    "surface.shortName": "course",
    "surface.defaultCondition": "condition"
  };

  const keyGreyhoundsRace = ["distance", "raceClass.name"];
  const dataArr = get(race, "isGreyhound") ? keyGreyhoundsRace : keysRace;

  const surfaceChanges = pickBy(get(race, "changes.surface"));
  const resArr: RaceListItem[] = [];
  forEach(dataArr, (item: string) => {
    const defRes = {
      item,
      changed:
        enableRaceChanges &&
        Object.keys(surfaceChanges).indexOf(changesKeyMap[item]) !== -1,
      changes: enableRaceChanges ? surfaceChanges[changesKeyMap[item]] : [],
      changeKeyword: changesKeyMap[item]
    };

    if (has(race, item)) {
      if (item === "raceClass.shortName" && get(race, "claimingPrice", 0) > 0) {
        resArr.push({
          ...defRes,
          value: `${formatPurse(get(race, "claimingPrice", 0))} ${get(
            race,
            item
          )}`
        });
      } else if (item === "purse") {
        resArr.push({
          ...defRes,
          value: `${formatPurse(get(race, "purse", 0))} purse`
        });
      } else {
        const raceItem = get(race, item);
        if (raceItem) {
          resArr.push({
            ...defRes,
            value:
              item === "numWagerableRunners" ? `${raceItem} runners` : raceItem
          });
        }
      }
    }
  });

  return map(resArr, (e) => omit(e, "item"));
};

const RaceHdrUtils = {
  createRaceDataForHeader
};

export default RaceHdrUtils;
